import { MenuItemDefinition } from '@neos/core'

export const menuItems: Record<string, MenuItemDefinition> = {
  AssignPermission: {
    to: 'AssignPermissionToRolesListUI',
  },
  CommercialModule: {
    icon: 'module',
    to: 'CommercialModuleListUI',
  },
  CommercialModuleVolumetry: {
    to: 'CommercialModuleVolumetryUI',
  },
  CommercialSolutions: {
    icon: 'commercialSolution',
    to: 'CommercialSolutionListUI',
  },
  Customers: {
    icon: 'customer',
    to: 'CustomerListUI',
  },
  CustomUIViewListUI: {
    icon: 'createCustomView',
    to: 'CustomUIViewListUI',
  },
  Feature: {
    icon: 'feature',
    to: 'FeatureListUI',
  },
  FeatureTechnicalFunction: {
    to: 'FeatureTechnicalFunctionUI',
  },
  Licenses: {
    icon: 'license',
    to: 'LicenseListUI',
  },
  Permission: {
    to: 'PermissionUI',
  },
  TechnicalFunction: {
    icon: 'technicalFunction',
    to: 'TechnicalFunctionListUI',
  },
  UserAccount: {
    to: 'UserAccountListUI',
  },
  UserAccountUserRole: {
    to: 'UserAccountUserRoleUI',
  },
  UserSettings: {
    to: 'UserSettingsUI',
  },
  VolumetryTypes: {
    icon: 'volumetryDesignation',
    to: 'VolumetryTypeUI',
  }
}